var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.06,12.74h0a1.26,1.26,0,0,0-.92.38,1.28,1.28,0,0,0-.38.92,1.3,1.3,0,1,0,1.3-1.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,8.64a6.46,6.46,0,0,0-4.57,1.9l-.29.29,1.53,1.53.29-.3a4.31,4.31,0,0,1,6.12,0l.29.3,1.53-1.53-.29-.29A6.46,6.46,0,0,0,12,8.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionBad);
export default __webpack_public_path__ + "static/media/connection-bad.2c2395ac802377d25be763249c958d3c.svg";
export { ForwardRef as ReactComponent };